export default "__VITE_ASSET__HJxCLD1J__"